import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';

import './styles.scss';
import paystub from './images/paystub.png';
import license from './images/license.png';

class UploadTypePage extends React.Component {
  setFocustInptHandl = type => () => {
    if (this[type]) {
      this[type].click();
    }
  }

  uploadInput = null;
  cameraInput = null;

  uploadHandl = (e) => {
    if (e.target.files && e.target.files[0]) {
      const fd = new FormData();
      fd.append('file', e.target.files[0]);
      fd.append('type', this.props.type);

      this.props.uploadFile(fd);
    }
  }

  renderTitle = () => {
    switch (this.props.type) {
      case 2:
        return 'Last 3 months of bank account activity';
      case 1:
        return 'Upload a paystub photo';
      default:
        return 'Upload your driver’s license';
    }
  }

  render () {
    if (!this.props.isOpen) return null;
    return (
      <div className="page-upload-type">
        <div>
          <button className="type-button" onClick={this.props.modalHandl} >
            <i className="material-icons">close</i>
          </button>
          <PageTitle> { this.renderTitle() } </PageTitle>
        </div>

        <div className="upload-type-list">
          <div className="type-image" style={{ backgroundImage: `url(${this.props.type === 0 ? license : paystub})` }} />
        </div>
        <div className="hidden">
          <input
            type="file"
            accept="image/*"
            onChange={this.uploadHandl}
            ref={(link) => { this.uploadInput = link; }}
          />
          <input
            type="file"
            accept="image/*;capture=camera"
            onChange={this.uploadHandl}
            ref={(link) => { this.cameraInput = link; }}
          />
        </div>
        <Button
          onClick={this.setFocustInptHandl('uploadInput')}
        >
			Upload from gallery
        </Button>
        <Button
          onClick={this.setFocustInptHandl('cameraInput')}
        >
			Take a photo
        </Button>
      </div>
    );
  }
}

UploadTypePage.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
  modalHandl: PropTypes.func.isRequired,
  uploadFile: PropTypes.func.isRequired
};

export default connect(null, null)(UploadTypePage);



// WEBPACK FOOTER //
// ./src/pages/Upload/UploadType/index.js